import React from 'react';
import i18n from '../../../i18n/i18n';

import LazyImage from '../../../components/LazyImage';

import increaseVisibilityImg from "../../../images/bulkListing/increase-visibility.png";
import digitalizedApplicationImg from "../../../images/bulkListing/digitalized-application.png";
import marketingEffortsImg from "../../../images/bulkListing/marketing-efforts.png";
import convenientDashboardImg from "../../../images/bulkListing/convenient-dashboard.png";

const solutionsList = [
  {
    image: increaseVisibilityImg,
    title: i18n.t("bulkListing.solutionsBanner.increaseVisibility"),
    alt: "increase-visibility-img"
  },
  {
    image: digitalizedApplicationImg,
    title: i18n.t("bulkListing.solutionsBanner.digitalizedApp"),
    alt: "digitalized-application-img"
  },
  {
    image: marketingEffortsImg,
    title: i18n.t("bulkListing.solutionsBanner.marketingEfforts"),
    alt: "marketing-efforts-img"
  },
  {
    image: convenientDashboardImg,
    title: i18n.t("bulkListing.solutionsBanner.convenientDashboard"),
    alt: "convenient-dashboard-img"
  },
];

const SolutionsBanner = () => {
  return (
    <div className="w-full bg-primary900 p-[25px] md:py-[50px] md:px-[70px] lg:py-[30px] lg:px-[100px] xl:px-[200px] 2xl:px-[300px]">
      <div className="flex flex-col items-center my-[15px]">
        <div className="text-[15px] text-white font-bold text-center md:text-[20px]">{i18n.t("bulkListing.solutionsBanner.title")}</div>
        <div className="flex flex-row flex-wrap justify-center mt-[20px]">
          {solutionsList.map((solution, index) => (
            <div className="flex flex-col w-[220px] items-center m-[5px]" key={`solution-${index}`}>
              <LazyImage className="w-[50%] object-contain" src={solution.image} alt={solution.alt} />
              <div className="flex h-[65px] mt-[20px] justify-center">
                <div className="mx-[20px] text-white text-[11px] font-medium text-center md:text-[12px]">{solution.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default SolutionsBanner;